import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import IconLangs from "./_langs";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";
import TranslateButton from "../../../components/buttons/TranslateButton";

// labels
import {PH_CODE, PH_DESCRIPTION, PH_NAME} from "../../../components/i18n/placeHolders"
import {
    LB_CODE,
    INTERNATIONAL,
    LB_NAME,
    LB_STATUS,
    REQUIRED,
    LB_IS_MAIN,
    LB_DESCRIPTION,
    LB_IS_ACTIVE
} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {iconService} from "../../../jwt/_services/landings/iconService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";



const IconForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app
    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState(!!domainObject?.status);
    const [isMain, setIsMain] = useState(!!domainObject?.isMain);
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required( REQUIRED ),
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            code: domainObject?.code,
            description: domainObject?.description,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                langs,
                status: !!status,
                isMain: !!isMain
            }
        };

        if (!editMode)
            genericIndexedActions.save(path, iconService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, iconService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={iconService} path={path} />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                            {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_NAME}</Label>
                            <Input
                                type="text"
                                name="name"
                                placeholder={PH_NAME}
                                innerRef={register}
                            />
                            { errors.name && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.name?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_DESCRIPTION}</Label>
                            <Input
                                type="textarea"
                                name="description"
                                placeholder={PH_DESCRIPTION}
                                innerRef={register}
                            />
                            { errors.description && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.description?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>{LB_IS_ACTIVE}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label>{LB_IS_MAIN}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={isMain}
                                onChange={ () => setIsMain(!isMain) }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <IconLangs
                        langs={langs}
                        setLangs={setlangs}
                        translatableLangs={translatableLangs}
                    />
                </CardBody>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default IconForm